import type { HostingPleskSiteProfileInput } from '@tosho/contracts';
import wordpress from '../assets/cms/wordpress-logo.png?no-inline';
import prestashop from '../assets/cms/prestashop-logo.png?no-inline';
import matomo from '../assets/cms/matomo-logo.png?no-inline';

export const SITE_CMS: Readonly<
  Record<HostingPleskSiteProfileInput['cms'], { name: string; logo: string | null }>
> = {
  UNKNOWN: { name: 'À déterminer', logo: null },
  WORDPRESS: { name: 'WordPress', logo: wordpress },
  PRESTASHOP: { name: 'PrestaShop', logo: prestashop },
  MATOMO: { name: 'Matomo Analytics', logo: matomo },
  OTHER: { name: 'Autre CMS', logo: null },
  FROM_SCRATCH: { name: 'from scratch', logo: null },
};
export const SITE_ENVIRONMENTS: Readonly<
  Record<HostingPleskSiteProfileInput['environment'], string>
> = {
  UNSPECIFIED: 'À préciser',
  PRODUCTION: 'Production',
  DEVELOPMENT: 'Développement',
  STAGING: 'Recette / Préproduction',
  ARCHIVE: 'Archive',
};
export const EMPTY_SITE_PROFILE: HostingPleskSiteProfileInput = Object.freeze({
  cms: 'UNKNOWN',
  otherCms: null,
  environment: 'UNSPECIFIED',
  createdOn: null,
});
/** Jour calendaire déclaré : ne pas lui appliquer le fuseau du navigateur. */
export function siteCreationDate(value: string): string {
  const [year, month, day] = value.split('-');
  return `${day}/${month}/${year}`;
}
